export const CHART_MENU_ITEMS = [
  { key: 'fullscreen', label: 'View in full screen' },
  { key: 'print_chart', label: 'Print chart' },
  { key: 'download_png', label: 'Download PNG image' },
  { key: 'download_jpeg', label: 'Download JPEG image' },
  { key: 'download_pdf', label: 'Download PDF document' },
];
